import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import dashboard from '../views/dashboard/index.vue'
import Login from '../views/auth/login.vue'
import store from '../store/index'
import business_setup from '../views/business_setup/index.vue'
import accounting_service from '../views/accounting_service/index.vue'
import call_details from '../views/call_details/index'
import ask_an_expert from '../views/ask_an_expert/index.vue'
import profile from '../views/user_profile/index.vue'
import Tour from '../views/tour/index.vue'
import billing from '../views/billing/index.vue'
import grievances from '../views/grievances/index.vue'
import documents from '../views/documents/index.vue'
// import AuthService from '../services/auth'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: dashboard,
      meta: {
        userRequiresAuth: true
    },
  },
  {
    path: '/tour',
    name: 'Tour',
    component: Tour,
      meta: {
        userRequiresAuth: true
    },
  },
  {
    path: '/workspace/:type/:activity_type/:id',
    name: 'workspace',
    component: Home,
      meta: {
        userRequiresAuth: true
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      userRequiresAuth: false
  },
  },
  {
    path: '/business_setup',
    name: 'business_setup',
    component: business_setup,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/ask_an_expert',
    name: 'ask_an_expert',
    component: ask_an_expert,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/accounting_service',
    name: 'accounting_service',
    component: accounting_service,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/billing',
    name: 'billing',
    component: billing,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/grievances',
    name: 'grievances',
    component: grievances,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/documents',
    name: 'documents',
    component: documents,
    meta: {
      userRequiresAuth: true
    },
  },
  {
    path: '/call_details',
    name: 'call_details',
    component: call_details,
    meta: {
      userRequiresAuth: true
    },
  },
  
]
const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const AuthStatus=store.getters['auth/isLoggedIn']
  if(to.matched.some(record => record.meta.userRequiresAuth)) {
    if (AuthStatus) {
      next()
      return
    }
    next('/login') 
  } else {
    if(to.fullPath=='/login' && AuthStatus){
      return next('/');
    }
    next() 
  }
})

export default router
